import React from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TableCell,
  TableBody,
  Table,
  TableRow
} from "@material-ui/core";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionIcon from "@material-ui/icons/Description";
import placeholder from "lib/images/featured-image-tmp.png";
import moment from "moment";
import numeral from "numeral";
import Styles from "./tileStyles";
import { PIPELINE, CLOSED } from "constants/status";

const Tile = class extends React.Component {
  state = {
    hover: 0
  };

  hoverActions = () => {
    this.setState({ hover: 2 });
  };

  hoverOutActions = () => {
    this.setState({ hover: 0 });
  };

  formatCurrencyHelper = value => {
    if (!value) return null;
    return numeral(value).format("$0,0");
  };

  formatPercentageHelper = value => {
    if (!value) return null;
    return `${value}%`;
  };

  formatDecimalHelper = value => {
    if (!value) return null;
    return numeral(value).format("0.00");
  };

  formatConvertToPercentageHelper = value => {
    if (!value) return null;
    return numeral(value).format("0.0000%");
  };

  render() {
    const { deal, openNotes, status } = this.props;

    if (status.indexOf(deal.dealStatusId) === -1) return null;
    
    let img = placeholder;
    if (deal.imageMedium) img = `${deal.imageMedium}`;
    
    return (
      <Grid item xs={3}>
        <Styles>
          <Card
            elevation={this.state.hover}
            className="card"
            onMouseOver={this.hoverActions}
            onFocus={this.hoverActions}
            onMouseOut={this.hoverOutActions}
            onBlur={this.hoverOutActions}
          >
            <CardMedia className="media" image={img}>
              <div className={`card-overlay ${this.state.hover ? "up" : ""}`}>
                <Link to={`/portfolio/funds/${deal.fundId}/deals/${deal.id}`}>{deal.name}</Link>
              </div>
              <div
                className={`actions ${this.state.hover ? "show" : "hidden"}`}
              >
                <div className="actions-container">
                  <Button
                    // component={Link}
                    // to={`/deals/${deal.id}`}
                    className="action-button"
                  >
                    <AddAlertIcon />
                  </Button>
                  <Button
                    // component={Link}
                    // to={`/deals/${deal.id}`}
                    className="action-button"
                  >
                    <AccessTimeIcon />
                  </Button>
                  <Button
                    onClick={() => {
                      openNotes("deal", deal.id);
                    }}
                    className="action-button"
                  >
                    <DescriptionIcon />
                  </Button>
                </div>
              </div>
            </CardMedia>

            {status === CLOSED ? (
              <CardContent className="card-content">
                <Table>
                  <TableBody>
                    {/* <TableRow>
                      <TableCell>Status</TableCell>
                      <TableCell>{deal.status}</TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell>Current Balance</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.currentBalance
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Maturity</TableCell>
                      <TableCell>
                        {deal.overviewData.maturity
                          ? moment
                              .utc(deal.overviewData.maturity)
                              .format("MM/DD/YYYY")
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Rate</TableCell>
                      <TableCell>
                        {deal.overviewData ? deal.overviewData.rate : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Monthly Payment</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.monthlyPayment
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Prepayment Penalty</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.prepaymentPenalty
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Recourse</TableCell>
                      <TableCell>
                        {deal.overviewData ? deal.overviewData.recourse : null}
                      </TableCell>
                    </TableRow>
                    {/*
                    <TableRow>
                      <TableCell>Metrics</TableCell>
                      <TableCell>
                        <Switch
                          color="primary"
                          value="metrics"
                          checked={deal.metrics}
                        />
                      </TableCell>
                    </TableRow>
                    */}
                  </TableBody>
                </Table>
              </CardContent>
            ) : (
              <CardContent className="card-content">
                <Table>
                  <TableBody>
                    {/* <TableRow>
                      <TableCell>Status</TableCell>
                      <TableCell>{deal.status}</TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell>Current Balance</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.currentBalance
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Targeted Closing</TableCell>
                      <TableCell>
                        {deal.targetedClosing
                          ? moment
                              .utc(deal.targetedClosing)
                              .format("MM/DD/YYYY")
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Rate</TableCell>
                      <TableCell>
                        {deal.overviewData ? deal.overviewData.rate : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Monthly Payment</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.monthlyPayment
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Purchase Price</TableCell>
                      <TableCell>{deal.purchasePrice}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Prepayment Penalty</TableCell>
                      <TableCell>
                        {deal.overviewData
                          ? deal.overviewData.prepaymentPenalty
                          : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>LTV</TableCell>
                      <TableCell>{deal.ltv}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Recourse</TableCell>
                      <TableCell>
                        {deal.overviewData ? deal.overviewData.recourse : null}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Expected Loan Amount</TableCell>
                      <TableCell>{deal.expectedLoanAmount}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Expected Term</TableCell>
                      <TableCell>{deal.expectedTerm}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            )}
          </Card>
        </Styles>
      </Grid>
    );
  }
};

export default Tile;
